module.exports = __webpack_public_path__ + "static/media/IMG_0788.7068fe81.JPG";